import PropTypes from 'prop-types';

import CartCarrotProduct from './CartCarrotProduct';

const CartCarrot = (props) => {
  const { location, cart } = props;

  const carrot = cart?.carrots?.[location];

  if (!carrot || !location) {
    return null;
  }

  const locationCssClassname = location.split(' ').join('-').toLowerCase();
  if (carrot.type === 'Product Upsell' && !carrot.product) {
    return null;
  }
  return (
    <div
      className={`c7-cart__cart-carrot c7-cart__cart-carrot-${locationCssClassname}`}
    >
      <div
        className={`c7-cart__cart-carrot-${locationCssClassname}__message`}
        dangerouslySetInnerHTML={{ __html: carrot.content }}
      />
      {carrot.type === 'Product Upsell' && (
        <CartCarrotProduct product={carrot.product} />
      )}
    </div>
  );
};

CartCarrot.propTypes = {
  location: PropTypes.oneOf([
    'Side Cart Top',
    'Side Cart Bottom',
    'Cart Page Inline'
  ]).isRequired
};

export default CartCarrot;
